var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoltSmallRun({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9453 9.79057C15.8605 9.62285 15.6884 9.51683 15.4999 9.51626H12.9979V6.52377C13.0089 6.2989 12.8675 6.09454 12.6526 6.02502C12.4465 5.95743 12.2202 6.02994 12.0922 6.20457L8.0889 11.6908C7.9868 11.8379 7.97153 12.0282 8.04887 12.1896C8.12037 12.3748 8.29528 12.5002 8.49423 12.5088H10.9963V15.5012C10.9964 15.717 11.1358 15.9082 11.3416 15.9751C11.3918 15.9906 11.4441 15.999 11.4967 16C11.6568 16.0004 11.8075 15.9244 11.902 15.7955L15.9053 10.3093C16.0152 10.1576 16.0307 9.95726 15.9453 9.79057Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltSmallRun);
export default ForwardRef;